import React from 'react';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

const SortableItem = ({ id, children, isActive, onClick }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  
  return (
    <div ref={setNodeRef} style={style} className={`flex items-center mb-2 p-2 rounded-lg transition-colors ${isActive ? 'bg-blue-100 ring-1 ring-blue-500' : 'bg-gray-50 hover:bg-gray-100'}`}>
        <button {...attributes} {...listeners} className="mr-3 text-gray-400 hover:text-gray-600 cursor-grab active:cursor-grabbing">
            <GripVertical size={16} />
        </button>
        <div onClick={onClick} className="flex-1 cursor-pointer font-medium text-sm text-gray-700 capitalize select-none">
            {children}
        </div>
    </div>
  );
};

export const DraggableSectionList = ({ items, onReorder, activeSection, onSectionChange }) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);
      onReorder(arrayMove(items, oldIndex, newIndex));
    }
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        <div className="space-y-1">
            {items.map((id) => {
                 // Format ID for display
                 let displayText = id.replace(/_/g, ' ');
                 if (id.startsWith('custom_')) displayText = 'Custom Section'; 
                 // We will need a way to pass the actual Title for custom sections, but for now simple ID
                 return (
                    <SortableItem 
                        key={id} 
                        id={id} 
                        isActive={activeSection === id} 
                        onClick={() => onSectionChange(id)}
                    >
                        {displayText}
                    </SortableItem>
                 )
            })}
        </div>
      </SortableContext>
    </DndContext>
  );
};
